<template>
  <div class="w-table-wrap" style="max-height: 1400px;" >
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI KES'" >
         <template #title>
            SENARAI KES
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedList = !isMinimizedList">
                  <template v-if="isMinimizedList">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
      <div v-show="!isMinimizedList">
      <div class="w-table-wrap" style="max-height: 1400px;" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " style="line-height: 35px">
            <table >
              <tbody>
              <tr class="row_data">
                 <td><b>Tarikh AI</b><i aria-hidden="true" style=" color: red;">*</i></td>
                 <td><b>:</b></td>
                 <td>
                  <template v-if="(datas.lkp_status_id==34 && datas.pemeriksaan!=1) || datas.lkp_status_id==32 || datas.lkp_status_id==27">
                  <w-input type="date" v-model="datas.tarikh_ai" outline :validators="[validators.required]"></w-input>
                  </template>
                  <template v-else>
                    {{$zutil.dateformat(datas.tarikh_ai)}} 
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br>
        <div >
          <table class="w-table" color="light" :title="'MAKLUMAT TERNAKAN'">
            <thead>
              <tr>
                <th class="w-table__header  text-center" width="1%">BIL</th>
                <th class="w-table__header  text-center">NO KES AI</th>
                <th class="w-table__header  text-center">ID | NAMA | BAKA TERNAKAN</th>
                <!-- <th class="w-table__header  text-center">PENENTUAN AI<i aria-hidden="true" style=" color: red;">*</i></th> -->
                <th class="w-table__header  text-center">INVENTORI<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">SUMBER SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">JENIS SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">ID TERNAKAN | NAMA TERNAKAN | NO BATCH SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">HARGA SEMEN STRAW(RM)</th>
                <th class="w-table__header  text-center">NO. INSEMINASI</th>
                <th class="w-table__header  text-center">BIL STRAW SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">TARIKH JANGKAAN PD<i aria-hidden="true" style=" color: red;">*</i></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="ternakan_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in ternakan_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" style="margin:5px;"><div style="width: 210px"></div>{{dt.no_kes}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.ternakan_nama}} | {{dt.baka}}</td>

                  <td class="w-table__cell text-left" style="margin:10px;"><div style="width: 190px"></div>
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                        <template v-if="dt.inventori == 1">
                            STPP
                        </template>
                        <template v-else-if="dt.inventori == 2">
                            PERSENDIRIAN
                        </template>
                        <template v-else>

                        </template>

                     </template>
                     <template v-else>
                        <!-- <template v-if="$zutil.anyRole(['4','7','9']) && $zutil.anyCan(['3','4'])"> -->

                        <template v-if="$zutil.anyRole(['4']) || $zutil.anyRole(['7']) || $zutil.anyRole(['9']) || $zutil.anyCan(['3'])">
                            <!-- <w-select style="margin:10px;" label='' placeholder="Pilih Satu.." outline @input="lookupStock(dt)" :items="kategori_inventori" v-model="dt.inventori"/> -->
                            <w-select
                              style="margin:10px;"
                              label=""
                              placeholder="Pilih Satu.."
                              outline
                              :items="kategori_inventori"
                              v-model="dt.inventori"
                              @input="dt.lkp_kategori_semen_id = '' "
                            />
                        </template>
                        <template v-else>
                            {{ setPersendirian(dt) }}
                           PERSENDIRIAN
                        </template>
                     </template>
                  </td>

                  <td class="w-table__cell text-left" style="margin:15px;"><div style="width: 210px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                      {{dt.lkp_kategori_semen}}
                    </template>
                    <template v-else>
                      <!-- <w-select style="margin:10px;" placeholder="Pilih Satu.." outline :items="kategori_semen" v-model="dt.lkp_kategori_semen_id" :validators="[validators.required]"/> -->
                      <!-- <w-select style="margin:10px;" placeholder="Pilih Satu.." outline :items="kategori_semen" @input="lookupStock(dt)" v-model="dt.lkp_kategori_semen_id" /> -->
                        
                        <w-select
                          style="margin:10px;"
                          placeholder="Pilih Satu.."
                          outline
                          :items="filterKategoriSemen(dt)"
                          v-model="dt.lkp_kategori_semen_id"
                          @input="lookupStock(dt)"
                          :disabled="!dt.inventori"
                        />
                    </template>
                  </td>
                  <td class="w-table__cell text-left" style="margin:10px;"><div style="width: 190px"></div>
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                     {{dt.jenis_semen_ket}}
                     </template>
                     <template v-else>
                        <w-select style="margin:10px;" label='' placeholder="Pilih Satu.." outline @input="lookupStock(dt)" :items="lkp_baka" v-model="dt.jenis_semen"/>
                     </template>
                  </td>
                  <td class="w-table__cell text-left" style="margin:10px;"><div style="width: 320px"></div>
                     <!-- <template v-if="dt.lkp_kategori_semen_id==3">
                        <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                           {{dt.id_ternakan_batch}} | {{dt.no_batch}}  
                        </template>
                        <template v-else>
                           <w-flex wrap :gap="2">
                              <div class="grow mb2" style="min-width: 200px">
                                 <w-input placeholder="ID Ternakan" v-model="dt.id_ternakan_batch" :validators="[validators.required]"/>
                              </div>
                              <div class="grow mb2" style="min-width: 200px">
                                 <w-input placeholder="No Batch Semen" v-model="dt.no_batch" :validators="[validators.required]"/>
                              </div>
                           </w-flex>
                        </template>
                     </template>
                     <template v-else> -->
                     
                        <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                         {{dt.no_batch_keterangan}}
                        </template>
                        <template v-else>
                         <!-- <z-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt)" outline :items="dt.list_stock" v-model="dt.se_stock_id" :validators="[validators.required]"/> -->
                         <!-- {{dt.list_stock.length}} {{dt.lkp_kategori_semen_id}} -->
                                <table width="100%">
                                  <tbody>
                                  <tr>
                                    <td v-if="dt.lkp_kategori_semen_id == 3">
                                        <template v-if="dt.list_stock.length == 0">
                                          <!-- <template v-if="dt.no_batch_keterangan">
                                            {{dt.no_batch_keterangan}}
                                          </template> -->
                                          <!-- <template v-else> -->
                                           Tiada stok semen
                                         <!-- </template> -->
                                        </template>
                                        <template v-else>
                                            <w-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt, 1)" outline :items="dt.list_stock" v-model="dt.se_stock_id"/>
                                      </template>
                                    </td>
                                    <td v-else>
                                        <template v-if="dt.list_stock.length == 0">

                                           <template v-if="dt.no_batch_keterangan">
                                            <!-- {{dt.no_batch_keterangan}} -->
                                          </template>
                                          <template v-else>
                                           Tiada stok semen
                                         </template>
                                        </template>
                                        <template v-else>
                                            <w-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt, 1)" outline :items="dt.list_stock" v-model="dt.se_stock_id"/>
                                        </template>
                                    </td>
                                    <!-- <td v-if="dt.lkp_kategori_semen_id == 3 && (dt.list_stock.length == 0)"> -->
                                    <td v-if="dt.lkp_kategori_semen_id == 3 ">
                                      <w-button dark class="green--bg ml1" @click="perekodanNew(dt)" >
                                        <w-icon class="mr1">fal fa-plus</w-icon> 
                                    </w-button>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                 
                                 
                            
                      </template>
                    <!-- </template> -->
                  </td>
                  <td class="w-table__cell text-right" style="margin:5px;"><div style="width: 100px"></div>
                     <template v-if="dt.lkp_kategori_semen_id==3 && (datas.lkp_status_id==27||datas.lkp_status_id==34)">
                        <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="dt.harga_straw" outline :validators="[validators.required]"/> -->
                        
                        {{$zutil.formatDecimal(dt.harga_straw)}}
                     </template>
                     <template v-else>
                        {{$zutil.formatDecimal(dt.harga_straw)}}
                     </template>
                  </td>
                  <td class="w-table__cell text-right" style="margin:5px;">
                      {{dt.bil_inseminasi}}
                  </td>
                  <td class="w-table__cell text-right" style="margin:5px;"><div style="width: 120px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                      {{dt.bil_straw}}
                    </template>
                    <template v-else>
                      <!-- <w-input style="margin:5px;" class="mt4" outline v-model="dt.bil_straw" @keyup="cekBakiStraw(dt)" :validators="[validators.required]" :disabled="!dt.se_stock_id"/> -->
                      <w-input style="margin:5px;" class="mt4" type="number" outline v-model="dt.bil_straw" @keyup="cekBakiStraw(dt)" :disabled="!dt.se_stock_id && dt.lkp_kategori_semen_id!=3"/>
                    </template>
                  </td>
                  <td class="w-table__cell text-center" style="margin:3px;"><div style="width: 210px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                      {{$zutil.dateformat(dt.jankaan_biang_semula)}}
                    </template>
                    <template v-else>
                      <w-input type="date" outline v-model="dt.jankaan_biang_semula" :validators="[validators.required]"></w-input>
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      </div>
      </w-card>
      <br><br>
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" >
         <template #title>
            CAJ PERKHIDMATAN AI
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedCaj = !isMinimizedCaj">
                  <template v-if="isMinimizedCaj">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
         <div v-show="!isMinimizedCaj">
         <br>
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>1.</b></td>
                     <td width="22%"><b>Konsultasi / Perkhidmatan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <w-radios
                             :items="ya_tidak"
                             v-model="datas.konsutasi_ya_tidak"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.konsutasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi" @input="kiraan_caj(datas)"  outline/>
                        </div>
                        <div v-else>
                           RM {{$zutil.formatDecimal(datas.konsutasi)}}
                        </div>
                     </td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
            <!-- <div class="mx2"></div>
            <div class="grow " style="line-height: 35px">
               <table >
                  <tr class="row_data">
                     <td v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">RM</td>
                     <td>
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                        <div style="margin:5px;" class="fw-normal my1 fs-1">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi" @input="kiraan_caj(datas)"  outline/></div>
                        </div>
                        <div v-else>
                        </div>
                     </td>
                     <td></td>
                     <td></td>
                  </tr>
               </table>
            </div>
            <div class="mx2"></div> -->
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
            <table class="w-table" color="light" width="100%">
              <thead>
                <tr>
                  <td width="2%"><b>2. </b></td>
                  <td align="left" width="25%"><b>Harga Semen</b></td>
                  <td align="center" width="20%"><b>ID Ternakan | No Batch</b></td>
                  <td align="center" width="20%"><b>Harga (RM)</b></td>
                  <td align="center" width="13%"><b>Kuantiti</b></td>
                  <td align="center" width="20%"><b>Jumlah (RM)</b></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td align="left">i. SEMEN SUBSIDI JABATAN (IBVK) </td>
                  <td align="center">-
                     <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                     {{stock.no_batch_keterangan}}
                     </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                     <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                     {{$zutil.formatDecimal(stock.harga)}}
                      </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>ii. SEMEN SUBSIDI JABATAN (NEGERI)</td>
                  <td align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{stock.no_batch_keterangan}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{$zutil.formatDecimal(stock.harga)}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>iii. SEMEN PERSENDIRIAN</td>
                  <td align="center">
                     <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{stock.no_batch_keterangan}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{$zutil.formatDecimal(stock.harga)}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-right" align="right">
                    <div v-if="persendirian.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
         </div>
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>3.</b></td>
                     <td width="22%"><b>Caj Perjalanan (RM)</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                           
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_pengangkutan"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                            <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_pengangkutan==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                     </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                            RM {{$zutil.formatDecimal(datas.pengangkutan)}}
                        </div>
                     </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="mx2"></div>
        </div>



         <div class="w-flex wrap smd-column" >
            <!-- <div class="mx2"></div> -->
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%"><b>4.</b></td>
                     <td width="22%"><b>Caj Lain-Lain (Jika Ada) (RM)</b></td>
                     <td width="1%"><b>:</b></td>
                     <td width="20%">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_caj_lain"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                             <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_caj_lain==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td width="1%"><b></b></td>
                     <td width="24%" align="right">
                    </td>
                     <td width="31%" align="right">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                              <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_lain" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                             RM {{$zutil.formatDecimal(datas.caj_lain)}}
                        </div>
                     </td>
                  </tr>
                  <template v-if="datas.caj_lain!=0">
                  <tr class="row_data">
                     <td width="1%"><b></b></td>
                     <td width="22%"><b>Nyatakan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td colspan="2">
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                              <z-input style="margin:5px;" label="" class="mt4" v-model="datas.nyatakan" @input="kiraan_caj(datas)" placeholder="Sila Masukan.." :validators="[validators.required]" outline/>
                        </div>
                        <div v-else>
                            <b>{{datas.nyatakan}}</b>
                        </div> 
                     </td>
                     <td colspan="2"></td>
                  </tr>
                  </template>
                  <template v-else>
                  <tr class="row_data">
                     <td colspan="7"><div style="margin:17px;" class="fw-normal my1 fs-1"></div>  </td>
                     <td></td>
                  </tr>
                  </template>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                 <tbody>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Keseluruhan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.keseluruhan)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Subsidi Kerajaan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.subsidi)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Yang Perlu Dibayar</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="3%"><b>RM</b></td>
                     <td valign="top" width="18%">
                        <b>{{$zutil.formatDecimal(datas.perlu_bayar)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
        </div>

         </div>
      </w-card>

      

      <w-flex class="mt3" wrap align-center justify-end v-if="(datas.lkp_status_id==34)||(datas.perkhidmatan==1 && datas.lkp_status_id==27)">
        <w-button class="my1" :loading="loading" :disabled="loading" type="submit">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
      </w-flex>
    </w-form>

  </div>
    <w-dialog
          v-model="dialogPerekodanNew.show"
          :fullscreen="dialogPerekodanNew.fullscreen"
          width="900"
          :persistent="dialogPerekodanNew.persistent"
          :persistent-no-animation="dialogPerekodanNew.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                  TAMBAH STOK SEMEN PERSENDIRIAN KE INVENTORI
        </template>
            

            <w-form ref="form_perekodan" v-model="dialogPerekodanNew.valid" @validate="validateFormPerekodan" @success="success">
                <div class="w-flex wrap smd-column" >
                    <div class="grow " >
                        <!-- {{se_pengeluaran}} -->

                        <!-- {{form.dat}} -->
                        <w-input class="mt4" label="Tarikh Pendaftaran*" type="date" v-model="form_perekodan.tarikh" :validators="[validators.required]"/>
                        <br>
                         <w-input label="No Batch *" v-model="form_perekodan.no_batch" :validators="[validators.required]" />
                         <br>
                        <!-- <template v-if="form.id == 0"> -->
                           <!-- <z-select class="mt4" :items="se_pengeluaran" @input="pilihNoBatch" label="No Batch *"  v-model="form.se_pemungutan_id" :validators="[validators.required]"/> -->
                        <!-- <div class="spacer"></div>
                        <br>
                        <w-input label="No Batch *" v-model="form.no_batch" :validators="[validators.required]"/>
                        <div class="spacer"></div> -->
                        <w-input label="Nama Pengeluar Semen *" v-model="form_perekodan.nama_pengeluar_s" :validators="[validators.required]"/>
                       <z-select class="mt4" :items="lkp_negara" label="Negara Pengeluar Semen *" @input="pilihNegara" v-model="form_perekodan.lkp_negara_id" :validators="[validators.required]"/>
                       <br>
                        <!-- <table width="100%">
                            <tr>
                                <td width="80%">
                                     <z-select class="mt4" :items="se_katalog" label="ID Ternakan*" @input="pilihNoBatch" v-model="form.se_katalog_id" :validators="[validators.required]"/>
                                </td>
                                <td width="20%">
                                     <w-button dark class="green--bg ml1" @click="KategoriNew" >
                                <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH KATALOG
                            </w-button>
                                </td>
                            </tr>
                        </table> -->
                   
                       <!--  <div class="spacer"></div>
                        <br>
                        <w-input label="Nama Ternakan" v-model="form_perekodan.nama_ternakan" readonly/>
                        <div class="spacer"></div>
                        <br>
                        <w-input label="Baka" v-model="form_perekodan.baka" readonly/>
                        <div class="spacer"></div>
                        <br> -->

                
                        <!-- <w-input label="Tarikh Pengeluaran" type="date" v-model="form.tarikh_pengeluaran"/>
                        <div class="spacer"></div>
                        <br> -->
                        <!-- <w-input label="Bilangan Straw Dikeluarkan*" type="number" v-model="form.bil_straw" :validators="[validators.required]"/> -->
                        <!-- <br> -->
                        <w-input label="Bilangan Straw Didaftarkan*" type="number" v-model="form_perekodan.baki" :validators="[validators.required]"/>
                        <z-money class="mt4" label="Harga Perstraw (RM) *" v-model:originalValue="form_perekodan.harga" :validators="[validators.required]"/>
                    </div>
                    <div class="mx2"></div>
                    <div class="grow " >
                        <!-- <z-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form_perekodan.lkp_ternakan_id" @input="getJurusan(form_perekodan.lkp_ternakan_id)" :validators="[validators.required]"/>
                        <z-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form_perekodan.lkp_jurusan_id" @input="getBaka(form_perekodan.lkp_jurusan_id)" :validators="[validators.required]"/> -->

                         <z-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form_perekodan.lkp_ternakan_id" :validators="[validators.required]" disabled/>
                        <z-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form_perekodan.lkp_jurusan_id" :validators="[validators.required]" disabled/>
                        <z-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form_perekodan.lkp_baka_id"  :validators="[validators.required]" disabled/>
                        <z-select class="mt4" :items="lkp_gred" label="Generasi "  v-model="form_perekodan.lkp_gred_id" />
                        <w-select class="mt4" :items="jantina" label="Jantina *"  v-model="form_perekodan.jantina"  :validators="[validators.required]" disabled/>
                        
                        <br>
                    </div>
                    <div class="mx2"></div>
                    <div class="grow " >
                        <br>
                        <w-input label="ID Ternakan *" type="text" v-model="form_perekodan.kode"  :validators="[validators.required]"/>
                        <w-input class="mt4" label="Nama Ternakan " type="text" v-model="form_perekodan.nama" :validators="[validators.required]"/>
                        <w-input class="mt4" label="Tarikh Lahir *" type="date" v-model="form_perekodan.tarikh_lahir" :validators="[validators.required]"/>
                        <z-select class="mt4" :items="kepemilikan" label="Pemilik *"  v-model="form_perekodan.kepemilikan"  :validators="[validators.required]"/>
                        <z-select class="mt4" :items="lkp_negara" label="Negara Asal *"  v-model="form_perekodan.lkp_negara_asal_id"  :validators="[validators.required]"/>
                         <z-select class="mt4" :items="lkp_status_kategori" label="Status *"  v-model="form_perekodan.lkp_status_id"  :validators="[validators.required]" v-if="form_perekodan.id > 0"/>
                    </div>

                </div>

            </w-form>
          
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogPerekodanNew.show = false">TUTUP</w-button>
            <w-button class="ml1" :loading="dialogPerekodanNew.loading" :disabled="dialogPerekodanNew.valid === false" @click="$refs.form_perekodan.validate()">SIMPAN</w-button>
         </template>
    </w-dialog>

    <w-dialog
          v-model="dialogKategori.show"
          :fullscreen="dialogKategori.fullscreen"
          width="800"
          :persistent="dialogKategori.persistent"
          :persistent-no-animation="dialogKategori.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                  TAMBAH KATALOG
        </template>
         <w-form ref="form_kategori" v-model="form_kategori.valid" @validate="validateFormKategori" @success="success">
        
            <div class="w-flex wrap smd-column" >
                <div class="grow " >
                    <z-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form_kategori.lkp_ternakan_id" @input="getJurusan(form_kategori.lkp_ternakan_id)" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form_kategori.lkp_jurusan_id" @input="getBaka(form_kategori.lkp_jurusan_id)" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form_kategori.lkp_baka_id"  :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_gred" label="Generasi "  v-model="form_kategori.lkp_gred_id" />
                    <w-select class="mt4" :items="jantina" label="Jantina *"  v-model="form_kategori.jantina"  :validators="[validators.required]" disabled/>
                    
                    <br>
            
                </div>
                  <div class="mx2"></div>
                  <div class="grow " >
                    <br>
                    <w-input label="ID Ternakan *" type="text" v-model="form_kategori.kode"  :validators="[validators.required]"/>
                    <w-input class="mt4" label="Nama Ternakan " type="text" v-model="form_kategori.nama" />
                    <w-input class="mt4" label="Tarikh Lahir *" type="date" v-model="form_kategori.tarikh_lahir" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="kepemilikan" label="Pemilik *"  v-model="form_kategori.kepemilikan"  :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_negara" label="Negara Asal *"  v-model="form_kategori.lkp_negara_id"  :validators="[validators.required]"/>
                     <z-select class="mt4" :items="lkp_status_kategori" label="Status *"  v-model="form_kategori.lkp_status_id"  :validators="[validators.required]" v-if="form_kategori.id > 0"/>
                </div>

                  <div class="mx2"></div>
                  <div class="grow " >
                    <w-input class="mt4" label="Nama Bapa" type="text" v-model="form_kategori.nama_bapa" />
                    <w-input class="mt4" label="ID Bapa" type="text" v-model="form_kategori.id_bapa" />
                    <w-input class="mt4" label="Nama Ibu" type="text" v-model="form_kategori.nama_ibu" />
                    <w-input class="mt4" label="ID Ibu" type="text" v-model="form_kategori.id_ibu" />
                    <w-textarea class="mt4"  label="Ciri-ciri"  v-model="form_kategori.ciri_ciri" />
                    <div class="grow " >
                        <template v-if="$zutil.anyRole(['1', '3', '7', '9'])">
                          <w-input class="mt4" type="file" :preview="false" accept="application/pdf" v-model="files" multiple>Muat Naik Sijil Pedigree dan Prestasi PDF</w-input>
                            <template v-for="dt, ind  in attahecment">
                                <div class="fw-normal my1 fs-1">  
                                  <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                                </div>
                            </template>
                        </template>
                        <br><br>
                    </div>
                  </div>
             </div>
         </w-form>
        <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogKategori.show = false">TUTUP</w-button>
            <!-- <w-button class="ml1" :loading="dialogKategori.loading" :disabled="dialogKategori.valid === false" @click="$refs.form.validate()">SIMPAN</w-button> -->
             <w-button class="ml1" :loading="dialogKategori.loading" :disabled="form_kategori.valid === false" @click="$refs.form_kategori.validate()">SIMPAN</w-button>
         </template>
    </w-dialog>

</template>

<script>

import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
export default {
  components: {
    VueperSlides, VueperSlide
  },
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.ai-aiman',
      form : {},
      form_kategori : {
                        jantina : 1
                    },
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      ternakan_list:[],
      list_stock:[],
      lkp_penentuan_ai:[],
      kategori_semen:[],

      kategori_inventori:[
         {value: 1, label: "STPP"},
         {value: 2, label: "PERSENDIRIAN"},
      ],

      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      ya_tidak:[
         {value: 1, label: "Berbayar"},
         {value: 2, label: "Subsidi"},
      ],
      kepemilikan: [
         {value: 1, label: "Tempatan", disabled:this.$zutil.anyRole(['7', '9'])},
         {value: 2, label: "Luar Negara",}
      ],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => value !== '' || !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      ibvk:[],
      negri:[],
      listStock :[],
      persendirian:[],
      nyatakan_wajib:true,
      isMinimizedCaj: false,
      isMinimizedList: false,
      lkp_baka:[],
      list_stock_1: [],
      lkp_negara:[],
      se_katalog: [],

      lkp_ternakan : [],
      lkp_jurusan : [],
      lkp_baka : [],
      lkp_gred : [],
      lkp_status_kategori : [],
      jantina : [],
      fileCiri2: [],
      files:[],
      img:[],
      attahecment:[],
      attahecmentImg:[],
      attahecmentImg:[],

      dialogPerekodanNew: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      dialogKategori: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 900,
        item: {}
      },
      
    }
  },
  methods:{
    setPersendirian(dt) {
      if (dt) {
        dt.inventori = 2
      }
    },
    filterKategoriSemen(dt) {

          if (!dt || !dt.inventori) {
            return this.kategori_semen || []
          }

          // user wajib punya role 4 DAN 7 DAN 9 DAN permission 3
        if ( this.$zutil.anyRole(['4']) && this.$zutil.anyRole(['7']) && this.$zutil.anyRole(['9']) && this.$zutil.anyCan(['3']) && this.$zutil.anyCan(['4']) ) {
            // inventori = 1 → hanya IBVK (1) & DVS NEGERI (2)
            if (dt.inventori == 1) {
              return (this.kategori_semen || []).filter(x =>
                x.value == 1 || x.value == 2
              )
            }else if (dt.inventori == 2) {
              return this.kategori_semen || []
            }else{

                return this.kategori_semen || []
            }
            
        }else if ( this.$zutil.anyRole(['7', '9'])){

              return this.kategori_semen || []

        }else{
            return this.kategori_semen || []
        }

    },

    perekodanNew(dt){

         this.form_perekodan = {
          harga : null,
          jantina : 1,
          lkp_baka_id : dt.jenis_semen,
          lkp_ternakan_id : dt.lkp_ternakan_id,
          lkp_jurusan_id : dt.lkp_jurusan_id,

         }
        // alert(this.form.dat);

        this.dialogPerekodanNew.show = true;
        this.form.saveButton = "Simpan"
        this.getNegara()
        this.getKatalog()

        // this.getTernakanKategori(this.datas.lkp_ternakan_id)
        this.getGred()
        this.getStatus()
        this.getJantina()
    },

    KategoriNew(){
        this.dialogKategori.show = true;
        this.form.saveButton = "Simpan"
        this.getTernakanKategori(this.datas.lkp_ternakan_id)
        this.getGred()
        this.getStatus()
        this.getJantina()

    },
    pilihNoBatch(value){
      for (var i in this.se_katalog) {
         if (this.form.se_katalog_id == this.se_katalog[i].value) {
            // this.form.id_ternakan = this.se_pengeluaran[i].id_ternakan;
            this.form.nama_ternakan = this.se_katalog[i].nama_ternakan;
            this.form.baka = this.se_katalog[i].baka;
            this.form.lkp_negara_id = this.se_katalog[i].lkp_negara_id;
            // this.form.bil_straw = this.se_pengeluaran[i].jumlah_straw;
         }
      }
      // alert('asd');
   },
    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.lkp_negara = res
        this.load = this.load + 1
      })
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/se_katalog_luar', {}).then(res => {
        this.se_katalog = res
        this.load = this.load + 1
      })
   },
   pilihNegara(value){
      for (var i in this.lkp_negara) {
         if (this.form.lkp_negara_id == this.lkp_negara[i].value) {
            this.form.negara = this.lkp_negara[i].label;
         }
      }
      // alert('asd');
   },

   validateFormPerekodan() {
      this.loading=true;
      let isValid = true;
      if(!this.form_perekodan.tarikh || !this.form_perekodan.nama_pengeluar_s || !this.form_perekodan.lkp_negara_id || !this.form_perekodan.lkp_ternakan_id || !this.form_perekodan.lkp_baka_id || !this.form_perekodan.baki || !this.form_perekodan.harga || !this.form_perekodan.lkp_jurusan_id || !this.form_perekodan.kode || !this.form_perekodan.nama || !this.form_perekodan.tarikh_lahir || !this.form_perekodan.kepemilikan || !this.form_perekodan.lkp_negara_asal_id || !this.form_perekodan.no_batch 
         ){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.submitPerekodan();
    },

    submitPerekodan() {

        this.form_perekodan.hantar = 1;
        this.form_perekodan.lkp_status_id = 1;
        this.form_perekodan.jantina = 1;
        this.form_perekodan.kategori = 1;
        if (this.form_perekodan.hantar==1) {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            })
            .then((result) => {
                if (result.value) {
                        this.$zcomm.post('se.perekodan.store_persendirian' , this.form_perekodan)
                        .then(res => {
                           this.loading=false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                                this.$zutil.notify("Berjaya disimpan", true);
                                // this.$inertia.visit(this.$route('art.semakan.ai-aiman', this.datas.id));
                                // this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=2');
                                this.getStock(1);
                                // this.getTernakan();


                        })
                        .finally(() => {
                            this.dialogPerekodanNew.show = false;
                            
                                

                        });
                }else{ }

            })
        }

    },

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
        this.load = this.load + 1
      })
    },

    getTernakanKategori(i){
      this.$zcomm.get(this.api_service + 'lookup/ternakan_jenis/'+i, {}).then(res => {
        this.lkp_ternakan = res
        this.load = this.load + 1
      })
    },

    getJurusan(i){

      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
        this.load = this.load + 1
      })
    },

    getBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
        this.load = this.load + 1
      })
    },

    getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.lkp_gred = res
        this.load = this.load + 1
      })
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
        this.lkp_status_kategori = res
        this.load = this.load + 1
      })
    },

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.img) 
       {
           formData.append("files["+b+"]", this.img[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKatalog');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecmentImg();
           })
           .catch((err) => {})
           .finally(() => {});
   },

   deletelAttahecmentImg(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecmentImg();
       })
     }
   },

    getAttahecmentImg()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SeKatalog'}).then(res => {
        this.attahecmentImg = res
        this.slides = [];
       for (var b in this.attahecmentImg) {
          this.slides.push({title: this.attahecmentImg[b].information, image: this.attahecmentImg[b].url})
       }
      })
    },

    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SeKatalogCiri'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

    uploadPDF(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKatalogCiri');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },
   validateFormKategori() {
      this.loading=true;
      let isValid = true;
         
      if(!this.form_kategori.lkp_ternakan_id || !this.form_kategori.lkp_jurusan_id || !this.form_kategori.lkp_baka_id || !this.form_kategori.lkp_gred_id || !this.form_kategori.jantina || !this.form_kategori.kode || !this.form_kategori.nama || !this.form_kategori.tarikh_lahir || !this.form_kategori.kepemilikan || !this.form_kategori.lkp_negara_id){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.submitKategori();
    },

    submitKategori(){
        this.form_kategori.hantar = 1;
        this.form_kategori.lkp_status_id = 1;
        this.form_kategori.jantina = 1;
        this.form_kategori.kategori = 1;
      if(this.form_kategori.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if(this.form_kategori.id){
                this.$zcomm.update('se.katalog.update', this.form_kategori.id, this.form_kategori)
                .then(res => {
                   this.loading=false;
                  if(this.files.length > 0){
                     this.uploadPDF(res.id);
                  }
                  if (this.img.length > 0) {
                     this.uploadImg(res.id)
                  }
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  else if (this.form_kategori.hantar==1) {
        // alert(1234)
                     this.getKatalog();

                      // this.$inertia.visit(this.$route('se.katalog.show', this.form_kategori.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                     this.getKatalog();
                })
                .finally(() => {
                    this.dialogKategori.show = false;

                });
              }else{
                this.$zcomm.post('se.katalog.store' , this.form_kategori)
                .then(res => {
                   this.loading=false;
                  if(this.files.length > 0){
                     this.uploadPDF(res.id);
                  }
                  if (this.img.length > 0) {
                     this.uploadImg(res.id)
                  }
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);

                 
                  // this.$inertia.visit(this.$route('se.katalog.show', res.id));
                     this.getKatalog();

                })
                .finally(() => {
                    this.dialogKategori.show = false;

                });
              }
            }
          })
      }
    },
    
    
      kiraan_caj(){

      var total_harga = 0;

      let ibvk = [];
      ibvk = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 1)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let negri = [];
      negri = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 2)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let persendirian = [];
      persendirian = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id === 3)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           // no_batch_keterangan: item.id_ternakan_batch+' | '+item.no_batch,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,


      }));
     

        const groupBy = (key) => persendirian.sort((a, b) => a[key].localeCompare(b[key])).reduce((total, currentValue) => {
          const newTotal = total;
          if (
            total.length &&
            total[total.length - 1][key] === currentValue[key]
          )
            newTotal[total.length - 1] = {
              ...total[total.length - 1],
              ...currentValue,
              // harga: parseInt(total[total.length - 1].harga) + parseInt(currentValue.harga),
              total_harga: parseInt(total[total.length - 1].total_harga) + parseInt(currentValue.total_harga),
              kuantiti: parseInt(total[total.length - 1].kuantiti) + parseInt(currentValue.kuantiti),
            };
          else newTotal[total.length] = currentValue;
          return newTotal;



          
        }, []);

      this.persendirians = groupBy('no_batch_keterangan');

    console.log('No Batch List persendirians:', this.persendirians);


      const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);


      // const persen = persendirian.reduce((item) =>  item.no_batch_keterangan, item.harga_straw);


    // Output
    

    // const persen = groupBy(persendirian, ({ no_batch_keterangan}) => no_batch_keterangan );
    console.log('No Batch List:', ibvk);
      var no_batch_keterangan = [];
      for (var b in this.ternakan_list){
        if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
          no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
        // }else if (this.ternakan_list[b].lkp_jenis_hormon_id==2) {
        //   prid_delta_kuantiti+=1;
        //   prid_delta_harga = this.ternakan_sinkronisasi[b].harga;
        //   prid_delta_jumlah += Number(this.ternakan_sinkronisasi[b].harga);
        // }else if (this.ternakan_sinkronisasi[b].lkp_jenis_hormon_id==3) {
        //   jumlah_persendirian += Number(this.ternakan_sinkronisasi[b].harga_hormon_1) + Number(this.ternakan_sinkronisasi[b].harga_hormon_2) + Number(this.ternakan_sinkronisasi[b].harga_hormon_3)
        }
        // total_harga += Number(this.ternakan_list[b].harga);
      }
      this.ibvk = ibvk;
      this.negri = negri;
      this.persendirian = persendirian;

      this.datas.keseluruhan = Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
      if(this.datas.jenis_pengguna_pemohon == 1){
         if(this.datas.konsutasi_ya_tidak==2){ 
           
             // var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain);

            var subsidi = Number(totalIbvk) + Number(this.datas.konsutasi) + Number(totalNegri);
         }else{
            // var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.caj_lain);

            var subsidi = Number(totalIbvk) + Number(totalNegri);
         }

         if(this.datas.bayar_pengangkutan==2){ 
             var subsidi_pengangkutan =  Number(this.datas.pengangkutan) ;
         }else{
            var subsidi_pengangkutan = 0;
         }

         if(this.datas.bayar_caj_lain==2){ 
             var subsidi_lain =  Number(this.datas.caj_lain) ;
         }else{
            var subsidi_lain = 0;
         }

        this.datas.subsidi = subsidi + subsidi_pengangkutan + subsidi_lain;
        this.datas.perlu_bayar = this.datas.keseluruhan - subsidi -  subsidi_pengangkutan - subsidi_lain;

         // this.datas.subsidi = subsidi + subsidi_pengangkutan;
         // this.datas.perlu_bayar = this.datas.keseluruhan - subsidi;
      }else{
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(this.datas.konsutasi) + Number(totalNegri);
            // var perlu_bayar = Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri);
            // var perlu_bayar = Number(this.datas.konsutasi) + Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }
         if(this.datas.bayar_pengangkutan==2){ 
             var subsidi_pengangkutan =  Number(this.datas.pengangkutan) ;
         }else{
            var subsidi_pengangkutan = 0;
         }

         if(this.datas.bayar_caj_lain==2){ 
             var subsidi_lain =  Number(this.datas.caj_lain) ;
         }else{
            var subsidi_lain = 0;
         }

         this.datas.subsidi = subsidi + subsidi_pengangkutan + subsidi_lain;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi -  subsidi_pengangkutan - subsidi_lain;
      }
      if(this.datas.caj_lain == null || this.datas.caj_lain == 0){
         this.nyatakan_wajib = false;
      }else{
         this.nyatakan_wajib = true;
      }

      // console.log(datas.perlu_bayar)
    },
    lkpPenentuan()
    {
      this.$zcomm.get(this.api_service + 'lookup/penentuan_ai', {}).then(res => {
        this.lkp_penentuan_ai = res
      })
    },
    lkpKategoriSemen()
    {
      this.$zcomm.get(this.api_service + 'lookup/kategori_semen', {}).then(res => {
        this.kategori_semen = res
      })
    },
    lkpBerahi()
    {
      this.$zcomm.get(this.api_service + 'lookup/berahi', {}).then(res => {
        this.lkp_berahi = res
      })
    },
    chekLkpKategori(dt){
      if (dt.lkp_kategori_semen_id == 3) {
         dt.se_stock_id = null;
      }else{
         dt.no_batch = null;
         dt.id_ternakan_batch = null;
      }
    },

    lookupStock(dt)
    {
        // alert(dt.lkp_kategori_semen_id)
      dt.list_stock = []
      for (var b in this.listStock) {
         if (this.listStock[b].lkp_baka_id == dt.jenis_semen) {

            if(dt.lkp_kategori_semen_id == 3 && this.listStock[b].user_id == this.$page.props.auth.user.id && this.listStock[b].dvs == null && this.listStock[b].persendirian == 1){
              dt.list_stock.push({ 
                 baki: this.listStock[b].baki,
                 gred: this.listStock[b].gred,
                 harga: this.listStock[b].harga,
                 id_betina: this.listStock[b].id_betina,
                 id_jantan: this.listStock[b].id_jantan,
                 nama_jantan: this.listStock[b].nama_jantan,
                 label: this.listStock[b].id_jantan+' | '+this.listStock[b].nama_jantan+' | '+this.listStock[b].label ,
                 stage: this.listStock[b].stage,
                 value: this.listStock[b].value,
              });
            }


            // if(dt.lkp_kategori_semen_id == 2 && this.listStock[b].user_id != this.$page.props.auth.user.id && this.listStock[b].dvs == 1  && this.listStock[b].persendirian == null){
            if(dt.lkp_kategori_semen_id == 2 && this.listStock[b].dvs == 1  && this.listStock[b].persendirian == null){
              dt.list_stock.push({ 
                 baki: this.listStock[b].baki,
                 gred: this.listStock[b].gred,
                 harga: this.listStock[b].harga,
                 id_betina: this.listStock[b].id_betina,
                 id_jantan: this.listStock[b].id_jantan,
                 nama_jantan: this.listStock[b].nama_jantan,
                 label: this.listStock[b].id_jantan+'| '+this.listStock[b].nama_jantan+' | '+this.listStock[b].label ,
                 stage: this.listStock[b].stage,
                 value: this.listStock[b].value,
              });
            }

            // if(dt.lkp_kategori_semen_id == 1 && this.listStock[b].user_id != this.$page.props.auth.user.id && this.listStock[b].dvs != 1  && this.listStock[b].persendirian == null){
            if(dt.lkp_kategori_semen_id == 1 && this.listStock[b].dvs != 1  && this.listStock[b].persendirian == null && this.listStock[b].jumlah_agih > 0){
              dt.list_stock.push({ 
                 baki: this.listStock[b].baki,
                 gred: this.listStock[b].gred,
                 harga: this.listStock[b].harga,
                 id_betina: this.listStock[b].id_betina,
                 id_jantan: this.listStock[b].id_jantan,
                 nama_jantan: this.listStock[b].nama_jantan,
                 label: this.listStock[b].id_jantan+'| '+this.listStock[b].nama_jantan+' | '+this.listStock[b].label ,
                 stage: this.listStock[b].stage,
                 value: this.listStock[b].value,
              });
            }
         }
      }
      
    },

    getStock(ind){
      this.$zcomm.get(this.api_service + 'lookup/stock/1', {}).then(res => {
         this.listStock = res
         if(ind == 1){
          for (var b in this.ternakan_list) {
            if(this.ternakan_list[b].se_stock_id == null || this.ternakan_list[b].se_stock_id == ''){
              this.lookupStock(this.ternakan_list[b])
            }
          }
          
         }
      })
    },

    getHarga(dt, ind){
      if (dt.lkp_kategori_semen_id !=3 && (dt.se_stock_id == '' || dt.se_stock_id == null)) {
         dt.harga_straw = 0;
         dt.bil_straw = 0;
         this.kiraan_caj();
      }
      for (var b in this.listStock) {
        // if(dt.lkp_kategori_semen_id !=3 && this.listStock[b].value==dt.se_stock_id){
        if( this.listStock[b].value==dt.se_stock_id){
          dt.harga_straw = this.listStock[b].harga;
          dt.max_kuantiti_straw = this.listStock[b].baki;
          if(ind = 1){
            dt.no_batch_keterangan = this.listStock[b].label
          }
        }
      }

    },
    cekBakiStraw(dt){
      if(dt.lkp_kategori_semen_id !=3 && dt.bil_straw > dt.max_kuantiti_straw){
        dt.bil_straw = dt.max_kuantiti_straw;
      }
    },

    getTernakan(){
      // ternakan list

    this.kiraan_sumber(this.datas.tarikh_ai);
      this.datas.tarikh_ai = this.datas.tarikh_ai ? this.datas.tarikh_ai : this.datas.tarikh_pemeriksaan;
      for (var b in this.datas.ternakan_list) {
        if(this.datas.ternakan_list[b].bunting==2 && this.datas.ternakan_list[b].status_pemeriksaan ==1){
          this.getHarga(this.datas.ternakan_list[b], 0);
           this.kiraan_sumber(this.datas.ternakan_list[b]);
          
          this.ternakan_list.push({
            id:this.datas.ternakan_list[b].id,
            art_id:this.datas.ternakan_list[b].art_id,
            bil_inseminasi:this.datas.ternakan_list[b].bil_inseminasi,
            bil_straw:this.datas.ternakan_list[b].bil_straw,
            baka:this.datas.ternakan_list[b].baka,
            bunting:this.datas.ternakan_list[b].bunting,
            harga_straw:this.datas.ternakan_list[b].harga_straw,
            id_ternakan:this.datas.ternakan_list[b].id_ternakan,
            jankaan_biang_semula: this.datas.ternakan_list[b].jankaan_biang_semula || this.jankaanBiangSemula(this.datas.ternakan_list[b].jankaan_biang_semula),
            jankaan_kelahiran:this.datas.ternakan_list[b].jankaan_kelahiran,
            lkpBerahi_keterangan:this.datas.ternakan_list[b].lkpBerahi_keterangan,
            lkp_berahi_id:this.datas.ternakan_list[b].lkp_berahi_id,
            no_kes:this.datas.ternakan_list[b].no_kes,
            se_stock_id:this.datas.ternakan_list[b].se_stock_id,
            skor_badan:this.datas.ternakan_list[b].skor_badan,
            status:this.datas.ternakan_list[b].status,
            ternakan_id:this.datas.ternakan_list[b].ternakan_id,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            list_stock: this.datas.ternakan_list[b].list_stock,
            max_kuantiti_straw:this.datas.ternakan_list[b].max_kuantiti_straw,
            no_batch_keterangan:this.datas.ternakan_list[b].no_batch_keterangan,
            lkp_penentuan_ai:this.datas.ternakan_list[b].lkp_penentuan_ai,
            lkp_penentuan_ai_id:this.datas.ternakan_list[b].lkp_penentuan_ai_id,
            ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
            lkp_kategori_semen:this.datas.ternakan_list[b].lkp_kategori_semen,
            lkp_kategori_semen_id: this.datas.ternakan_list[b].lkp_kategori_semen_id,
            jenis_semen_ket: this.datas.ternakan_list[b].jenis_semen_ket,
            jenis_semen: this.datas.ternakan_list[b].jenis_semen,
            no_batch: this.datas.ternakan_list[b].no_batch,
            id_ternakan_batch:  this.datas.ternakan_list[b].id_ternakan_batch,
            lkp_status_id: this.datas.ternakan_list[b].lkp_status_id,

            lkp_ternakan_id: this.datas.ternakan_list[b].lkp_ternakan_id,
            lkp_jurusan_id: this.datas.ternakan_list[b].lkp_jurusan_id,
            inventori: this.datas.ternakan_list[b].inventori,
          })
        }
      }
      this.kiraan_caj();
    },

     kiraan_sumber(dt){
        if (dt.lkp_negeri_premis != dt.lkp_negeri_art ) {
            dt.lkp_kategori_semen_id = 3;
        }

     },

    //belum benar
    bilanganInseminasi() {
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      const tarikh_sekarang = new Date();

      const batasTanggal = new Date(tarikh_sekarang);
      batasTanggal.setMonth(batasTanggal.getMonth() + 3);
      if(tarikh_pemeriksaan == tarikh_sekarang){
        return 1;
      }else if(tarikh_pemeriksaan > tarikh_sekarang && tarikh_pemeriksaan <= batasTanggal){
        return 2;
      }else if(tarikh_pemeriksaan > batasTanggal){
         return 3;
      }
      return 1;
      // return formattedDate;
    },

    jankaanBiangSemula(tarikh){
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + this.datas.ternakan_biang_semula); //tambah  hari untuk lembu
      const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
      return formattedDate;
    },

    validateForm() {
      this.loading=true;
      let isValid = true;

      this.ternakan_list.forEach((row) => {
         // if (row.lkp_status_id !=28) {
         //    if (row.lkp_kategori_semen_id != 3 && row.se_stock_id == null || row.bil_straw == null || row.lkp_kategori_semen_id == null ) {
         //     isValid = false;
         //     this.loading=false;
         //    }

         //    if (row.lkp_kategori_semen_id == 3 && (row.id_ternakan_batch ==null || row.no_batch==null)) {
         //       isValid = false;
         //       this.loading=false;      
         //    }
         // }
         if (!row.lkp_kategori_semen_id && !row.se_stock_id || !row.bil_straw || !row.jankaan_biang_semula ) {
          isValid = false;
          this.loading=false;
         }
      });

      // if (this.datas.caj_lain != 0 || this.datas.caj_lain != null) {
      //    var caj_lain = true;
      // }else{
      //    var caj_lain = false;
      // }
      // alert(caj_lain);
      if (this.datas.caj_lain != 0 && this.datas.nyatakan == null || this.datas.tarikh_ai==null) {
         // alert(true);
         isValid = false;
         this.loading=false;
      }

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.ternakan_list, perkhidmatan:1, hantar:1})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=4');
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
         var param = {
            ternakan_list: this.ternakan_list,
            perkhidmatan:1,
            tarikh_ai:  this.datas.tarikh_ai,
            konsutasi: this.datas.konsutasi,
            pengangkutan: this.datas.pengangkutan,
            keseluruhan: this.datas.keseluruhan,
            subsidi: this.datas.subsidi,
            perlu_bayar: this.datas.perlu_bayar,
            caj_lain: this.datas.caj_lain,
            konsutasi_ya_tidak: this.datas.konsutasi_ya_tidak,
            bayar_pengangkutan: this.datas.bayar_pengangkutan,
            bayar_caj_lain: this.datas.bayar_caj_lain,
            nyatakan: this.datas.nyatakan,

          }
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, param)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=4');
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=4');
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
    // getbakaAll(){
    //      this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
    //        this.lkp_baka = res
    //      })
    //    },

    getBakaTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/baka_ternakan/'+this.datas.lkp_ternakan_id, {}).then(res => {
           this.lkp_baka = res
        })
    },

    getTernakanKategoriAll(){
        this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
         this.lkp_ternakan = res
         this.load = this.load + 1
       })
    },

    getJurusanAll(){
        this.$zcomm.get(this.api_service + 'lookup/jurusan_all', {}).then(res => {
         this.lkp_jurusan = res
         this.load = this.load + 1
       })
    },





  },

  
      
  mounted() {
   if (this.datas.tarikh_ai == null) {
      var today = new Date();
      this.datas.tarikh_ai = this.datas.tarikh_pemeriksaan;
   }
   if (this.form.id == 0) {
      var today = new Date();
       this.form.tarikh = today.toISOString().split('T')[0];
    }
    this.lkpBerahi()
    this.getTernakan();
    this.getStock(0);
    this.lkpKategoriSemen();
    this.lkpPenentuan();
    // this.getbakaAll();
    this.getBakaTernakan();
    this.getTernakanKategoriAll();
    this.getJurusanAll();
    

    // this.datas = this.data;
  }
}
      

</script>  
<style type="text/css">

/*.w-table__row {
  display: flex;
  align-items: center;
}*/
.w-table__cell {
  vertical-align: middle;
}

</style>
